import React, { useState, useRef } from "react";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { useHistory } from "react-router-dom";
import { postData, postData1 } from "../../services/http.service";
import Constants from "../../services/constant";
import body_part_dummy from "../../assets/demo/flags/body_part_dummy.svg";
import { Chips } from "primereact/chips";

const CreateBodyPart = () => {
    const toast = useRef(null);
    const history = useHistory();



 
   const [bodyPartImg,setBodyPartImg] = useState(null)
    const [bodyPartInfo, setBodyPartInfo] = useState("");

    const [err, setErr] = useState({});



    console.log("err", err);

    const validateForm = () => {
        let errors = {};
        if (!bodyPartInfo) {
            errors.name = " Name is required";
        }
        if (!bodyPartImg) {
            errors.image = "Image is required";
        }

        setErr(errors);
        if (Object.keys(errors).length === 0) {
            return true;
        } else {
            return false;
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const form = validateForm();
        if (form) {
            const formData = new FormData();
            formData.append("weaponImage", bodyPartImg);
            postData1(Constants.END_POINT.UPLOAD_IMAGE, formData)
                .then((res) => {
                    if (res.success) {
                        let payload = {
                            image:res?.data?.weaponImage,
                            name:bodyPartInfo
                        }
                        postData(Constants.END_POINT.CREATE_BODY_PART, payload)
                        .then((res) => {
                            if (res.success) {
                                toast.current.show({ severity: "info", summary: "", detail: "Body Part has been Created Succesfully", life: 3000 });
                                            setTimeout(()=>history.push("/body-part"), 1000)
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            window.scrollTo({
                top: 250,
                left: 0,
                behavior: "smooth",
            });
        }
    };




    return (
        <div className="grid">
            <div className="col-12 md:col-12 mx-auto">
                <Toast ref={toast} />
                <div className="card ">
                    <div className=" flex justify-content-center">
                        <h3>Add Body Part</h3>
                        <div className="ml-4 align-right"></div>
                    </div>
                    {/* <img src={product} alt="" width="10%" style={{ display: "block", marginLeft: "auto", marginRight: "auto" }} /> */}
                    <div className="p-fluid grid">
                        <div className="field col-12 md:col-12">
                            <div className="weapon-image-wrapper mt-4">
                                <div className="weapon-image-div">
                                    <img src={bodyPartImg ? URL.createObjectURL(bodyPartImg) : body_part_dummy} alt="" className="weaponImageTag" />
                                    {bodyPartImg!==null ?
                                    <div className="weapon-edit-div">
                                        <i onClick={()=>setBodyPartImg(null)}  className="fa-sharp fa-solid fa-trash delete"></i>
                                    </div>
                                    : null }
                                </div>

                                <input
                                    type="file"
                                    id="image"
                                    name="image"
                                    onChange={(e) => {
                                        setBodyPartImg(e.target.files[0]);
                                        setErr({ ...err, image: "" });
                                    }}
                                    onClick={(event)=> { 
                                        event.currentTarget.value = null
                                   }}
                                    hidden
                                />
                                <label htmlFor="image" className="weaponImageLabel">
                                    Add Image
                                </label>
                                <div className="text-danger">{err.image}</div>
                            </div>
                            {/* <div className="text-danger">{err.name}</div> */}
                        </div>
                        <div className="field col-12 md:col-6">
                            <span className="p-float-label mt-4">
                                <InputText id="name" name="name" onChange={(e)=>{setBodyPartInfo(e.target.value);setErr({ ...err, name: "" });}} value={bodyPartInfo} />
                                <label htmlFor="name">Name</label>
                            </span>
                            <div className="text-danger">{err.name}</div>
                        </div>
                        
                       
                    </div>
         

                    <div className="flex justify-content-left mt-3 ">
                        {
                            <Button type="button" className="p-button-md p-button-success" onClick={handleSubmit}>
                                Add Body Part
                            </Button>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateBodyPart;
